module.exports = __webpack_public_path__ + "img/dayc.83cd7edf.png";